import { inject, Injectable } from '@angular/core';
import { SquareRefundsEndpoints } from 'app/core/enums/endpoints/gateway.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';
import {
    LoadSquareRefundsQueryParams,
    LoadSquareUnlinkedRefundsQueryParams,
} from '../../types';

@Injectable({
    providedIn: 'root',
})
export class SquareRefundsService {
    private _endpoint = SquareRefundsEndpoints;
    private _apiService = inject(ApiService);

    // ------------------------------------------------------------------
    // @ Public Methods
    // ------------------------------------------------------------------

    getAll(params: LoadSquareRefundsQueryParams): Observable<any> {
        return this._apiService.getWithQueryParams(
            this._endpoint.getAll,
            params
        );
    }

    getUnlinked(params: LoadSquareUnlinkedRefundsQueryParams): Observable<any> {
        return this._apiService.getWithQueryParams(
            this._endpoint.getUnlinked,
            params
        );
    }

    markExpensed(params: {
        refundId: number;
        expense_register: boolean;
    }): Observable<any> {
        const { refundId, ...payload } = params;
        return this._apiService.update(
            this._endpoint.markExpensed,
            payload,
            params.refundId
        );
    }
}
